module.exports = __webpack_public_path__ + "img/HNG-tab.a603fb96.jpg";